export default __webpack_public_path__ + "static/media/tcdd_logo.2a9d8a53.png";